import OTPAlert from './OTPAlert';
import OTPErrorHandler from './OTPErrorHandler';

export default OTPAlert;

export { OTPErrorHandler };
